import React from 'react'
import { Breadcrumbs } from 'react-breadcrumbs'

export const BreadcrumbsUnstyled = props => (
  <div className={props.className}>
    {props.icon}
    <Breadcrumbs />
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Breadcrumbs/unstyled.js